import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

const baseUrl = '/api/common/ExportApi';
const defaultFileName = 'Export.xlsx';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  public constructor(private httpClient: HttpClient) { }

  public exportResultSetToExcel(
    body: any,
    options: any,
    action: string,
    fileName?: string,
  ): Observable<any> {
    return this.httpClient.post<any>(`${baseUrl}/${action}`, body, options).pipe(map((res: any) => ({
      filename: fileName ? `${fileName}.xlsx` : defaultFileName,
      data: new Blob(
        [res],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
      ),
    })));
  }
}
